import { render } from "./certificateList.vue?vue&type=template&id=166a834a"
import script from "./certificateList.vue?vue&type=script&lang=js"
export * from "./certificateList.vue?vue&type=script&lang=js"

import "./certificateList.vue?vue&type=style&index=0&id=166a834a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__